<template>
  <div id="made">
    <TabBar />
    <div class="made_banner"></div>
    <div class="made">
      <div class="container">
        <div class="home_item_content">
          <h6>Order process</h6>
          <i></i>
          <h1>定制流程</h1>
        </div>
        <div class="process_item">
          <div class="item_img">
            <div class="item_img_num">
              <img src="../assets/images/1.png" alt />
            </div>
            <img src="../assets/images/made_2.png" alt />
          </div>
          <div class="item_txt">
            <h3>提交需求</h3>
            <p>填写表格的内容，与公司人员沟通需求。</p>
          </div>
        </div>
        <div class="process_item top2">
          <div class="item_img">
            <div class="item_img_num">
              <img src="../assets/images/2.png" alt />
            </div>
            <img src="../assets/images/made_3.png" alt />
          </div>
          <div class="item_txt">
            <h3>策划</h3>
            <p>根据需求分析提供最专业的的策划服务。</p>
          </div>
        </div>
        <div class="process_item top3">
          <div class="item_img">
            <div class="item_img_num">
              <img src="../assets/images/3.png" alt />
            </div>
            <img src="../assets/images/made_4.png" alt />
          </div>
          <div class="item_txt">
            <h3>立项</h3>
            <p>签订合同，支付预付款。</p>
          </div>
        </div>
        <div class="process_item top4">
          <div class="item_img">
            <div class="item_img_num">
              <img src="../assets/images/4.png" alt />
            </div>
            <img src="../assets/images/made_5.png" alt />
          </div>
          <div class="item_txt">
            <h3>设计</h3>
            <p>根据需求进行交互图、设计图的制作。</p>
          </div>
        </div>
        <div class="process_item top5">
          <div class="item_img">
            <div class="item_img_num">
              <img src="../assets/images/5.png" alt />
            </div>
            <img src="../assets/images/made_6.png" alt />
          </div>
          <div class="item_txt">
            <h3>开发</h3>
            <p>开发人员根据设计图进行前台和后台的开发。</p>
          </div>
        </div>
        <div class="process_item top6">
          <div class="item_img">
            <div class="item_img_num">
              <img src="../assets/images/6.png" alt />
            </div>
            <img src="../assets/images/made_7.png" alt />
          </div>
          <div class="item_txt">
            <h3>测试</h3>
            <p>开发完成之后进行系统整体的测试。</p>
          </div>
        </div>
        <div class="process_item top7">
          <div class="item_img">
            <div class="item_img_num">
              <img src="../assets/images/7.png" alt />
            </div>
            <img src="../assets/images/made_8.png" alt />
          </div>
          <div class="item_txt">
            <h3>验收</h3>
            <p>签订验收单，把所有东西交付给客户。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="made_form">
      <div class="container2">
        <div class="home_item_content">
          <h6>personalization</h6>
          <i></i>
          <h1>个性化定制</h1>
        </div>
        <el-form class="madeForm">
          <div class="input_item">
            <span>行业：</span>
            <el-input></el-input>
          </div>
          <div class="input_item">
            <span>预算：</span>
            <el-input></el-input>
          </div>
          <div class="input_item">
            <span>姓名：</span>
            <el-input></el-input>
          </div>
          <div class="input_item">
            <span>电话：</span>
            <el-input></el-input>
          </div>
        </el-form>
        <div class="submit">
          <a href>确认提交</a>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
#made {
  height: 2000px;
}
.made_banner {
  background: url("../assets/images/made_banner.png") no-repeat;
  height: 500px;
  background-position: center;
  position: relative;
  top: 90px;
  margin-bottom: 90px;
  min-width: 1200px;
}
.made {
  background: url("../assets/images/made_1.png") no-repeat;
  height: 300px;
  background-position: center;
  margin-top: 305px;
  margin-bottom: 247px;
  min-width: 1200px;
  .container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 547px;
    .home_item_content {
      position: absolute;
      top: -96px;
      right: 240px;

      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background: rgba(38, 172, 255, 1);
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        line-height: 50px;
        font-weight: 500;
      }
    }
  }
}
.container {
  //border: 1px solid black;
  .top2 {
    top: -8px;
  }
  .top3 {
    top: 43px;
  }
  .top4 {
    top: 107px;
  }
  .top5 {
    top: 161px;
  }
  .top6 {
    top: 190px;
  }
  .top7 {
    top: 178px;
  }
  .process_item {
    width: 160px;
    position: relative;

    .item_txt {
      text-align: center;
      padding: 0 17px;
      h3 {
        font-size: 20px;
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
        line-height: 24px;
      }
    }
    .item_img {
      .item_img_num {
        position: absolute;
        right: 32px;
        top: -52px;
        z-index: -1;
      }
    }
  }
}
.made_form {
  background: url("../assets/images/made_9.png") no-repeat;
  background-position: center;
  height: 642px;
  min-width: 1200px;
  .container2 {
    width: 1200px;
    height: 642px;
    margin: 0 auto;
    padding: 100px;
    .madeForm {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .input_item {
        margin-bottom: 40px;
        span {
          color: #ffffff;
          line-height: 25px;
          font-size: 14px;
          display: inline-block;
          margin-right: 20px;
        }
        .el-input {
          width: 400px;
          height: 50px;
        }
      }
    }
    .home_item_content {
      color: #ffffff;
      margin-bottom: 60px;
      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background-color: #ffffff;
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        line-height: 50px;
        font-weight: 500;
      }
    }
  }
}
.submit {
  width: 240px;
  height: 52px;
  background: rgba(38, 172, 255, 1);
  box-shadow: 0px 5px 10px rgba(38, 172, 255, 0.3);
  opacity: 1;
  border-radius: 25px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  a {
    font-size: 16px;
    line-height: 52px;
    color: rgba(255, 255, 255, 1);
  }
}
</style>